function printWelcome() {
  const title = 'Welcome To Kingaro';

  const titleStyle = [
    'font-size: 42px',
    'font-weight: 800',
    'font-family: "Segoe UI", Tahoma, sans-serif',
    'padding: 18px 34px',
    'color: #ffffff',
    'background: linear-gradient(90deg, #7c3aed 0%, #db2777 50%, #f97316 100%)',
    'border-radius: 14px',
    'text-shadow: 0 2px 6px rgba(0,0,0,0.35)',
    'letter-spacing: 1px',
  ].join(';');

  const subStyle = [
    'font-size: 14px',
    'color: #a78bfa',
    'font-weight: 600',
    'padding: 6px 4px',
  ].join(';');

  console.log('%c🎮 ' + title + ' 🎮', titleStyle);
  console.log('%cبه فروشگاه کینگارو خوش آمدید — kingaro.com', subStyle);
}

if (import.meta.env.PROD) {
  printWelcome();
}
